<template>
  <div class="addNewTypeHeader">
    <div class="addNewTypeHeader-saveHolder">
      <button-com
        iconName="check"
        iconSize="small"
        text="Save"
        class="bm-confirm"
        @click.native="save"
      ></button-com>
    </div>
  </div>
</template>

<script>
export default {
  props: ['plural', 'singular', 'dataTypes'],
  computed: {
    feeds () {
      return this.$store.state.feeds
    },
    currentFeed () {
      return this.$store.state.currentFeed
    }
  },
  methods: {
    updateFeedHeader (key, value) {
      this.$store.commit({
        type: 'updateFeedHeader',
        key: key,
        value: value,
        feedGroupIndex: this.currentFeed,
        feedIndex: 0
      })
    },
    save () {
      this.updateFeedHeader('plural', this.plural)
      this.updateFeedHeader('singular', this.singular)
      this.updateFeedHeader('template', this.dataTypes)
      this.$http.post(
        'http://api.lootbox.se/saveChanges',
        {
          feeds: JSON.stringify(this.feeds)
        },
        {
          emulateJSON: true,
          withCredentials: true
        }
      ).then(() => {
        this.$router.push('/')
      }, () => {
        console.log('Fail!')
      })
    }
  }
}
</script>

<style lang="sass">
@import './../sass/core.sass'

+block('addNewTypeHeader')
  height: 100px
  display: flex
  align-items: center
  max-width: 708px
  margin: 0 auto
  position: relative
  padding: 0 30px

  +element('closeHolder')
    position: absolute
    right: 30px
    display: flex

  +element('saveHolder')
    position: absolute
    left: 50%
    transform: translateX(-50%)

</style>



// WEBPACK FOOTER //
// src/components/AddNewTypeHeader.vue